import { gql } from '@apollo/client';
import { BRAND_GROUP_FIELDS } from 'src/graphql/entities/brand-group';

export const PARTNER_FIELDS = gql`
  fragment PartnerFields on Partner {
    id
    partnerId
    timeZone
    businessName
    zendeskDomain
    currentPartner
    slackTeamLink
    notionBoardUrl
    docsendUrl
    dosCalendly
    supportEmail
    supportPhone
    supportLiveDate
    litsDate
    annual
    membershipSalesCalendlyLink
    globalNotificationEmail
    tos
    address
    city
    state
    zip
    billingEmail
    billingEmail2
    websiteUrl
    membershipEmail
  }
`;

export const PARTNER_ONESHEET_FIELDS = gql`
  fragment PartnerOneSheetFields on PartnerOnesheet {
    id
    partnerId
    mainOfficePhone
    asTransferForBusinessHoursOnly
    internalSupportNotes
    escalationPolicy
    recentAnnouncements
    whatIsYourEquipmentRepairPolicy
    primaryRsmTool
  }
`;

export const PARTNER_RELATIONS = gql`
  fragment PartnerRelations on Partner {
    id
    brandGroups {
      ...BrandGroupFields
    }
    partnerOnesheet {
      ...PartnerOneSheetFields
    }
  }
  ${BRAND_GROUP_FIELDS}
  ${PARTNER_ONESHEET_FIELDS}
`;
